module.exports = {"610628001":"茶坊街道","610628101":"羊泉镇","610628102":"张村驿镇","610628103":"张家湾镇","610628104":"直罗镇","610628106":"牛武镇","610628109":"寺仙镇","610628204":"北道德乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610628.json
// module id = 2842
// module chunks = 0